import { render } from "./DaysGenericFilters.vue?vue&type=template&id=2f304190"
import script from "./DaysGenericFilters.vue?vue&type=script&lang=js"
export * from "./DaysGenericFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__